import React, { Component } from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import actionCreators from 'actions/creators';
import { Route, Switch } from "react-router-dom";
import { ConnectedRouter } from 'react-router-redux';
import CupoyRouter from "components/commons/router/CupoyRouter";
import CupoyRouterView from "components/commons/router/CupoyRouterView";
import LogoutDialog from "components/dialog/LogoutDialog";
import ConfirmDialog from 'components/dialog/ConfirmDialog';
import AlartDialog from 'components/dialog/AlartDialog';
import DownloadTaxMediaDialog from 'components/dialog/DownloadTaxMediaDialog';
import LoginView from './LoginView';
import PrintAllowanceView from 'components/allowance/PrintAllowanceView';
import MainView from './MainView';

import "../scss/style.css";

class RootView extends Component {
    // constructor(props) {
    //     super(props);
    // }

    componentDidMount() {
        // check login, etc...
        this.props.adminActions.checkAdminLogin().then((result) => {
            // login success
        }, (error) => {
            this.props.webActions.cupoyStateGo(CupoyRouter.STATES.LOGIN);
        });
    }


    render() {

        return (
            <CupoyRouterView>
                <div id="container">
                    <ConnectedRouter history={this.props.history}>
                        <div className="full-height">
                            <Switch>
                                <Route path={CupoyRouter.PATHS.PRINT_ALLOWANCE} component={PrintAllowanceView} exact/>
                                <Route component={LoginView} path={CupoyRouter.PATHS.LOGIN} exact/>
                                <Route component={MainView}/>
                            </Switch>
                        </div>
                    </ConnectedRouter>
                    {this.props.isShowLogoutModal ? <LogoutDialog/> : null}
                    {this.props.confirmDialog.isOpen ? <ConfirmDialog /> : null}
                    {this.props.alartDialog.isOpen ? <AlartDialog /> : null}
                    {this.props.downloadTaxMediaDialog.isOpen ? <DownloadTaxMediaDialog /> : null}
                </div>
            </CupoyRouterView>
        );
    }
}

const mapStateToProps = function(state) {
    return {
        history: state.web.history,
        isLogin: state.admin.isLogin,
        isShowLogoutModal: state.web.isShowLogoutModal,
        confirmDialog: state.web.confirmDialog,
        alartDialog: state.web.alartDialog,
        downloadTaxMediaDialog: state.invoice.downloadTaxMediaDialog,
    };
};

const mapActionToProps = function(dispatch) {
    return {
        webActions: bindActionCreators(actionCreators.webActionCreators, dispatch),
        adminActions: bindActionCreators(actionCreators.adminActionCreators, dispatch)
    };
};

export default connect(mapStateToProps, mapActionToProps, null, {
    withRef: true
})(RootView);



// WEBPACK FOOTER //
// ./src/components/RootView.js